import { css } from 'styled-components'

export const thinStroke = css`
  svg [stroke-width='1.5'],
  svg [stroke-width='2'],
  svg [stroke-width='2.5'] {
    stroke-width: 1.5px;
    vector-effect: non-scaling-stroke;
  }
`
